import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import { Label, Input, handleCustomStyles, selectTheme, TextMessage } from './styles';
import { SchemeToSelectFormat, SchemeFlieldsToSelectFormat } from 'src/utils/formatting';
import { Box } from 'rebass';


/* Componente encargado de parametrizar la regla SaveToBigquery */
/*
 * @param  {} options: opciones del esquema
 * @param  {} regla: objeto con los parametros de esa regla
 * @param  {} handleChangeSelect: handle para cambiar la seleccion
 * @param  {} handleChangeInput: handle para el input
 * @param  {} error
 * @param  {} mError
 * @param  {} handleOnBlur
 */
const SaveToBigquery = ({
  options,
  regla,
  handleChangeSelect,
  handleChangeInput,
  error,
  mError,
  handleOnBlur
}) => {
  const { parameters } = regla;
  const optionsSchemas = SchemeToSelectFormat(options, 'esquema');
  const optionsCampos = parameters?.schema?.fields
    ? SchemeFlieldsToSelectFormat(parameters.schema.fields, 'campos')
    : [];
  let valuesMulti = [];
  if (typeof parameters.campos !== 'undefined' || parameters.campos !== '') {
    valuesMulti = parameters.campos;
  }
  const optionsWriteDisposition = [
    {
      value: 'WRITE_DISPOSITION_UNSPECIFIED',
      label: 'WRITE_DISPOSITION_UNSPECIFIED',
      name: 'write_disposition'
    },
    {
      value: 'WRITE_EMPTY',
      label: 'WRITE_EMPTY',
      name: 'write_disposition'
    },
    {
      value: 'WRITE_TRUNCATE',
      label: 'WRITE_TRUNCATE',
      name: 'write_disposition'
    },
    {
      value: 'WRITE_APPEND',
      label: 'WRITE_APPEND',
      name: 'write_disposition'
    }
  ];
  return (
    <Row>
      <Col md={6} xs={12}>
        <Label>Nombre de la tabla</Label>
        <Label required bold>*</Label>
        <Input
          name='table'
          placeholder='Nombre de la tabla'
          value={parameters.table}
          onChange={(e) => handleChangeInput({ e, id: regla.id })}
          error={error?.table}
          onBlur={handleOnBlur}
        />
        {error?.table ? (
          <Box mt={0} mb={0}>
            <TextMessage>{mError}</TextMessage>
          </Box>
        ) : null}
      </Col>
      <Col md={6} xs={12}>
        <Label>Nombre del dataset</Label>
        <Label required bold>*</Label>
        <Input
          name='dataset'
          placeholder='Nombre del dataset'
          value={parameters.dataset}
          onChange={(e) => handleChangeInput({ e, id: regla.id })}
          error={error?.dataset}
          onBlur={handleOnBlur}
        />
        {error?.dataset ? (
          <Box mt={0} mb={0}>
            <TextMessage>{mError}</TextMessage>
          </Box>
        ) : null}
      </Col>
      <Col md={6} xs={12}>
        <Label>Write Disposition</Label>
        <Label required bold>*</Label>
        <Select
          onChange={(e) => handleChangeSelect({ e, id: regla.id })}
          options={optionsWriteDisposition}
          placeholder='Seleccione Write Disposition'
          theme={selectTheme}
          value={
            typeof parameters.write_disposition === 'undefined' ||
              parameters.write_disposition === ''
              ? []
              : [
                {
                  value: parameters.write_disposition,
                  label: parameters.write_disposition
                }
              ]
          }
          styles={handleCustomStyles({ error: error?.write_disposition })}
          isDisabled={false}
          error={error?.write_disposition}
          onBlur={handleOnBlur}
        />
        {error?.write_disposition ? (
          <Box mt={0} mb={0}>
            <TextMessage>{mError}</TextMessage>
          </Box>
        ) : null}
      </Col>
      <Col md={6} xs={12}>
        <Label>Esquema</Label>
        <Label required bold>*</Label>
        <Select
          onChange={(e) => handleChangeSelect({ e, id: regla.id, dependentField: 'campos' })}
          options={optionsSchemas}
          placeholder='Seleccione Esquema'
          theme={selectTheme}
          value={
            typeof parameters.esquema === 'undefined' ||
              parameters.esquema === ''
              ? []
              : [{ value: parameters?.esquema, label: parameters?.esquema }]
          }
          styles={handleCustomStyles({ error: error?.esquema })}
          isDisabled={false}
          error={error?.esquema}
          onBlur={handleOnBlur}
        />
        {error?.esquema ? (
          <Box mt={0} mb={0}>
            <TextMessage>{mError}</TextMessage>
          </Box>
        ) : null}
      </Col>
      <Col md={6} xs={12}>
        <Label>Campos</Label>
        <Label required bold>*</Label>
        <Select
          onChange={(e) =>
            handleChangeSelect({ e, id: regla.id, nameNull: 'campos' })}
          options={optionsCampos}
          placeholder='Seleccione los campos'
          theme={selectTheme}
          value={valuesMulti}
          isDisabled={false}
          styles={handleCustomStyles({ error: error?.campos })}
          isMulti
          onBlur={handleOnBlur}
        />
        {error?.campos ? (
          <Box mt={0} mb={0}>
            <TextMessage>{mError}</TextMessage>
          </Box>
        ) : null}
      </Col>
    </Row>
  );
};

export default SaveToBigquery;
